import { Component, OnInit } from '@angular/core';
import { CommanService } from 'src/app/shared/services/comman.service';
declare  var jQuery:  any;
import * as moment from 'moment'

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  gallerygroupRequest: any = {
    pagesize: 6,
      page: 1,
  };
  groupList_last_page: boolean;
  groupList: any = "";
  constructor(
    private commanService: CommanService
  ) { }

  ngOnInit() {
    this.loadgalleryGroup();
  }

  getMoregroup() {
    this.gallerygroupRequest.page = this.gallerygroupRequest.page + 1;
    this.loadgalleryGroup(true);
    
  }

  loadgalleryGroup(concat:boolean = false){
    //this.gallerygroupRequest.lang = this.browserLang;
      let request = Object.assign({}, this.gallerygroupRequest)
      this.commanService.getGallaryGroup(request).then((data : any) => { 
       if(data.data.length > 0)
       {
         if (concat) {
          this.groupList = this.groupList.concat(data.data);
          window.setTimeout(function(){
           jQuery('.youtube-popup').magnificPopup({
              type: 'iframe',
              mainClass: 'mfp-fade',
              removalDelay: 160,
              preloader: false,
          
              fixedContentPos: false
            });
            //console.log("yes");
          }, 1000);
          //console.log(this.videoList);
         // this.shareVideos();
        } else {
          this.groupList = data.data
          //console.log(this.videoList);
          //this.shareVideos();
        }   
       }
       else{
        this.groupList_last_page = true;
        //console.log("hello");
       }
    });
    }

}
